import status from 'http-status';

import { questionnaireConstants as constants } from '../_constants/questionnaire.constants'
import { questionnaireService } from '../_services/questionnaires.service';
import { alertActions } from './alert.actions'
import { history } from '../_helpers/history';

import { reset as documentBuilderReset, getSuccess } from './document-builder.actions';

export function initState() {
  return { type: constants.QUESTIONNAIRE_INIT_STATE };
}

export function resetIds() {
  return { type: constants.QUESTIONNAIRE_RESET_IDS }
}

export function moveItem(fromIndexPosition, toHumanPosition) {
  return { type: constants.QUESTIONNAIRE_MOVE_ITEMS, fromIndexPosition, toHumanPosition }
}

export function rearrangeItems(from, to) {
  return { type: constants.QUESTIONNAIRE_REARRANGE_ITEMS, from, to }
}

export function get(id) {
  return dispatch => {
    dispatch(request());

    questionnaireService.get(id)
      .then((questionnaire) => {
        dispatch(success(questionnaire));
        dispatch(getSuccess(questionnaire.document));

      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve the questionnaire at this time. Please try again."));
      });
  }

  function request() { return { type: constants.QUESTIONNAIRE_GET_REQUEST } }
  function success(questionnaire) { return { type: constants.QUESTIONNAIRE_GET_SUCCESS, questionnaire } }
}

export function getAll() {
  return dispatch => {
    dispatch(request());

    questionnaireService.getAll()
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve the questionnaires at this time. Please try again."));
      });
  }

  function request() { return { type: constants.QUESTIONNAIRE_GETALL_REQUEST } }
  function success(collection) { return { type: constants.QUESTIONNAIRE_GETALL_SUCCESS, collection } }
  // function failure () { return { type: constants.QUESTIONNAIRE_GETALL_FAILURE }}
}

export function saveQuestionnaire() {
  return (dispatch, getState) => {
    const questionnaireStore = getState().questionnaire;
    const documentStore = getState().documentBuilder;

    const questionnaire = questionnaireStore.current;
    const noteTemplate = questionnaireStore.noteTemplate
    const document = documentStore.current;

    dispatch(request());

    questionnaireService.save(questionnaireStore.id, questionnaire, noteTemplate, document)
      .then(() => {
        dispatch(success(questionnaire));
        dispatch(documentBuilderReset());

        history.push('/questionnaires');

        if (questionnaireStore.id) {
          dispatch(alertActions.success('Questionnaire update!'));
        } else {
          dispatch(alertActions.success('Questionnaire saved!'));
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(failure());

          if (error.response.status === status.UNPROCESSABLE_ENTITY) {
            for (const validation in error.response.data) {
              dispatch(alertActions.error(error.response.data[validation]));
            }
          } else {
            dispatch(alertActions.error("Could not save questionnaire at this time. Please try again."));
          }
        }
      });
  };

  function request() { return { type: constants.QUESTIONNAIRE_SAVE_REQUEST } }
  function success() { return { type: constants.QUESTIONNAIRE_SAVE_SUCCESS } }
  function failure() { return { type: constants.QUESTIONNAIRE_SAVE_FAILURE } }
}

export function setSupportImage(item, url) {
  return { type: constants.QUESTIONNAIRE_SET_SUPPORT_IMAGE, item, url };
}

export function setNoteTemplate(noteTemplate) {
  return { type: constants.QUESTIONNAIRE_SET_NOTE_TEMPLATE, noteTemplate };
}

export function setNotePreview(notePreview) {
  return { type: constants.QUESTIONNAIRE_SET_NOTE_PREVIEW, notePreview }
}

export function setChoiceType(item, choiceType) {
  return { type: constants.QUESTIONNAIRE_SET_CHOICE_TYPE, item, choiceType };
}

export function answerQuestion(item, answer) {
  return { type: constants.QUESTIONNAIRE_ANSWER_QUESTION, item, answer }
}

export function setSupportLink(item, url) {
  return { type: constants.QUESTIONNAIRE_SET_SUPPORT_LINK, item, url };
}

export function updateOption(item, option, position) {
  return { type: constants.QUESTIONNAIRE_UPDATE_OPTION, item, option, position };
}

export function removeOption(item, option) {
  return { type: constants.QUESTIONNAIRE_REMOVE_OPTION, item, option };
}

export function addOption(item, option) {
  return { type: constants.QUESTIONNAIRE_ADD_OPTION, item, option };
}

export function setEditQuestion(item) {
  return { type: constants.QUESTIONNAIRE_EDIT_QUESTION, item };
}

export function markAsRequired(item, required) {
  return { type: constants.QUESTIONNAIRE_MARK_AS_REQUIRED, item, required };
}

export function markAsNote(item, note) {
  return { type: constants.QUESTIONNAIRE_MARK_AS_NOTE, item, note };
}

export function setQuestionnaireTitle(title) {
  return { type: constants.QUESTIONNAIRE_SET_TITLE, title };
}

export function setPatientType(patientType) {
  return { type: constants.QUESTIONNAIRE_SET_PATIENT_TYPE, patientType };
}

export function setDocumentSignature(signature) {
  return { type: constants.QUESTIONNAIRE_SET_SIGNATURE, signature }
}

export function setAppointmentType(appointmentType) {
  return { type: constants.QUESTIONNAIRE_SET_APPOINTMENT_TYPE, appointmentType };
}

export function editQuestionnaireTitle() {
  return { type: constants.QUESTIONNAIRE_EDIT_TITLE }
}

export function setItemText(item, text) {
  return { type: constants.QUESTIONNAIRE_SET_ITEM_TEXT, item, text };
}

export function addQuestion(question) {
  return { type: constants.QUESTIONNAIRE_ADD_ITEM, question };
};

export function removeQuestion(item) {
  return { type: constants.QUESTIONNAIRE_REMOVE_ITEM, item };
}

export function setWarning() {
  return { type: constants.QUESTIONNAIRE_SET_WARNING }
}